import useCarModelDelete from 'api/carModel/useCarModelDelete/useCarModelDelete';
import useCarModelList from 'api/carModel/useCarModelList/useCarModelList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CarModelEditModal from 'components/shared/Modals/carModel/CarModelEditModal/CarModelEditModal';
import CarModelInsertModal from 'components/shared/Modals/carModel/CarModelInsertModal/CarModelInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCarModelTableColumns from 'hooks/carModel/useCarModelTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CarModel = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCarModelList, loading, carModelList, pageRef] =
    useCarModelList(guid);

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCarModel, setEditChosenCarModel] = useState({});

  const [deleteRequest] = useCarModelDelete();

  const tableRef = useRef(null);

  const navigate = useNavigate();
  const { can } = usePermissions();

  const modelPermissions =
    permissions.general.categories.globalSettings.coddingSettings.carFactory
      .brands.models;

  const canCreate = can(modelPermissions.create);
  const canEdit = can(modelPermissions.edit);
  const canDelete = can(modelPermissions.delete);
  const canDetail = can(modelPermissions.series.view);

  useEffect(() => {
    if (!guid) return;
    getCarModelList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    if (!guid) return;
    getCarModelList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/carSeries/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCarModel(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useCarModelTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getCarModelList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCarModelList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCarModelList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(carModelList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={carModelList[page]}
          rows={carModelList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت مدل خودرو' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <CarModelInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCarModelList={getCarModelList}
          brandGuid={guid}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <CarModelEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenCarModel={editChosenCarModel}
          getCarModelList={getCarModelList}
        />
      ) : null}
    </>
  );
};

export default CarModel;
